import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-photo-camera",
  "use": "gw-photo-camera-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-photo-camera\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"M12 16c1.65 0 3-1.35 3-3 0-1.66-1.35-3-3-3-1.66 0-3 1.34-3 3 0 1.65 1.34 3 3 3Zm8-11h-3.17l-1.24-1.35A1.99 1.99 0 0 0 14.12 3H9.88c-.56 0-1.1.24-1.48.65L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2Zm-8 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol